import { getStateInfoFromAvailability } from "@faire/retailer-visitor-shared/features/Exclusivity/getStateInfoFromAvailability";
import {
  useExclusivityAvailability,
  Options,
} from "@faire/retailer-visitor-shared/hooks/exclusivity/useExclusivityAvailability";
import { IGetRetailerExclusivityAvailabilityWithBrandResponse } from "@faire/web-api--source/faire/exclusivity_agreement/client/IGetRetailerExclusivityAvailabilityWithBrandResponse";
import { useMemo } from "react";

/**
 * See useExclusivityAvailability.ts for more details on Options.
 */
export const useExclusivityAvailabilityWithState = (
  brandToken?: string,
  options?: Options
) => {
  const { availability, ...rest } = useExclusivityAvailability(
    brandToken,
    options
  );
  const state = useMemo(
    () => getStateInfoFromAvailability(availability),
    [availability]
  );

  const hasInstantExclusivity =
    availability?.exclusivity_availability_options?.some(
      (option) =>
        option.exclusivity_availability_type ===
        IGetRetailerExclusivityAvailabilityWithBrandResponse
          .IExclusivityAvailabilityOption.ExclusivityAvailabilityType
          .GLOBAL_MINIMUM
    ) ?? false;

  const hasCustomExclusivity =
    availability?.exclusivity_availability_options?.some(
      (option) =>
        option.exclusivity_availability_type ===
        IGetRetailerExclusivityAvailabilityWithBrandResponse
          .IExclusivityAvailabilityOption.ExclusivityAvailabilityType.REQUESTS
    ) ?? false;

  return {
    availability,
    state,
    hasInstantExclusivity,
    hasCustomExclusivity,
    ...rest,
  };
};
